import { useAuth } from '@modules/auth/hooks';
import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';

import { STUDY_INSIGHTS_CDC_TIER_1_RESULTS_BREAKDOWN_KEY } from '../constants';
import { CDCTier1ResultsBreakdownParams, CDCTier1ResultsBreakdownResponse } from '../types/cdc-tier-1-results-breakdown.types';
import { fetchCDCTier1ResultsBreakdown } from '../services/cdc-tier-1-results-breakdown.service';

const useQueryCDCTier1ResultsBreakdown = <TError = unknown>(
  params: CDCTier1ResultsBreakdownParams,
  options?: Omit<
  UseQueryOptions<
  CDCTier1ResultsBreakdownResponse | undefined,
  TError,
  CDCTier1ResultsBreakdownResponse,
  Array<string | (Date | undefined)>
  >,
  'initialData' | 'queryFn' | 'queryKey'
  >,
): UseQueryResult<CDCTier1ResultsBreakdownResponse> => {
  const { isAuthenticated } = useAuth();

  const enabledOption = options?.enabled !== undefined ? !!options?.enabled : true;

  return useQuery(
    [STUDY_INSIGHTS_CDC_TIER_1_RESULTS_BREAKDOWN_KEY, params.startDate, params.endDate],
    async () => await fetchCDCTier1ResultsBreakdown(params),
    {
      ...options,
      enabled: isAuthenticated === true && enabledOption,
    },
  );
};

export default useQueryCDCTier1ResultsBreakdown;
